import { render, staticRenderFns } from "./UpdatePriceList.vue?vue&type=template&id=27b87880&"
import script from "./UpdatePriceList.vue?vue&type=script&lang=js&"
export * from "./UpdatePriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports